import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import './styles.css';
import { AppProvider } from './store/app';
import { Layout } from './app/Layout';
import { Dashboard } from './views/Dashboard';
import { Projects } from './views/Projects';
import { ProjectDetail } from './views/ProjectDetail';
import { People } from './views/People';
import { StaffDetail } from './views/StaffDetail';
import { Teams } from './views/Teams';
import { Clients } from './views/Clients';
import { ClientDetail } from './views/ClientDetail';
import { Assignments } from './views/Assignments';
import { Onboarding } from './views/Onboarding';
import { Invoices } from './views/Invoices';
import { DataPoints } from './views/DataPoints';
import { Profile } from './views/Profile';
import { Settings } from './views/Settings';
import { Email } from './views/Email';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'projects', element: <Projects /> },
      { path: 'projects/:id', element: <ProjectDetail /> },
      { path: 'people', element: <People /> },
      { path: 'people/:id', element: <StaffDetail /> },
      { path: 'teams', element: <Teams /> },
      { path: 'clients', element: <Clients /> },
      { path: 'clients/:id', element: <ClientDetail /> },
      { path: 'assignments', element: <Assignments /> },
      { path: 'onboarding', element: <Onboarding /> },
      { path: 'invoices', element: <Invoices /> },
      { path: 'data', element: <DataPoints /> },
      { path: 'profile', element: <Profile /> },
      { path: 'settings', element: <Settings /> },
      { path: 'email', element: <Email /> },
      { path: '*', element: <Navigate to="/dashboard" replace /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  </React.StrictMode>,
);
